import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ProvinceForm from '../../../components/forms/ProvinceForm';
import { useProvinceById, useUpdateProvince } from '../../../hooks/useProvinceApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { ProvinceDTO } from '../../../services/apiClient';

const ProvinceEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useProvinceById(id!);
  const updateProvince = useUpdateProvince();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Provinces', href: '/admin/provinces' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateProvince.mutateAsync({ id: id!, data });
      navigate('/admin/provinces');
    } catch (error) {
      console.error('Error updating Province:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/provinces"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.Province.Edit'
    >
        {entityData ? (
          <ProvinceForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/provinces')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default ProvinceEdit;